// src/App.js
import React from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Whitepaper from './components/Whitepaper';
import MemeShowcase from './components/MemeShowcase';
import Community from './components/Community';
import Footer from './components/Footer';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Terms from './components/Terms';
import Privacy from './components/Privacy';

function App() {
    return (
        <Router>
            <Routes>
                {/* Main Landing Page */}
                <Route path="/" element={
                    <>
                        <Header />
                        <Hero />
                        <MemeShowcase />
                        <About />
                        <Whitepaper />
                        <Community />
                        <Footer />
                    </>
                } />
                {/* Terms and Privacy Pages */}
                <Route path="/terms" element={<Terms />} />
                <Route path="/privacy" element={<Privacy />} />
            </Routes>
        </Router>
    );
}

export default App;